import * as PhotoStatus from '../../../../../../../shared/PhotoStatus';
import { ImageCategory } from '../../shared/state/utils';

export function shouldShowCategoryButton(
    isSelecting: boolean,
    isStitching: boolean,
    photoStatus: number,
    effectiveCategory: number,
    isCustomerApproved?: boolean
): boolean {
    if (isSelecting || isStitching) {
        return false;
    }

    if (isCustomerApproved) {
        return false;
    }

    if (photoStatus >= PhotoStatus.CustomerApproved && effectiveCategory !== ImageCategory.Extra) {
        return false;
    }

    return true;
}
